export const Loading = () => {
  const skeletonItems = Array.from({ length: 8 }, (_, index) => index);
  return (
    <div className="w-full max-w-2xl mx-auto bg-white">
      {skeletonItems.map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between gap-3 p-4 border-b border-gray-100 last:border-b-0"
        >
          {/* Checkbox skeleton */}
          <div className="flex items-center space-x-4">
            <div className="w-5 h-5 bg-gray-200 rounded border animate-pulse"></div>

            {/* Property name skeleton */}
            <div className="space-y-1">
              <div
                className="h-5 bg-gray-200 rounded animate-pulse"
                style={{ width: `${Math.floor(Math.random() * 100) + 120}px` }}
              ></div>
            </div>
          </div>

          {/* Property count skeleton */}
          <div
            className="h-4 bg-gray-200 rounded animate-pulse"
            style={{ width: `${Math.floor(Math.random() * 40) + 80}px` }}
          ></div>
        </div>
      ))}
    </div>
  );
};
